<script>
// eslint-disable-next-line no-unused-vars
import { getApprovalBasicDetail, saveApprovalBasicDetail } from '@/api/approval'
import { initUserAndDepartments } from '@/api/user'

const APPROVAL_STATUE_MAP = {
  0: {
    name: '已停用',
    class: 'not-enabled'
  },
  1: {
    name: '已启用',
    class: 'is-enabled'
  }
}

const APPPROVAL_TYPE_MAP = {
  1: '报销'
}

let DEPARTMENT_MAP = {}
let USER_MAP = {}

function getViewerDom(ctx, h) {
  console.log('h, ctx', h, ctx)
  let res = []

  res.push(
    <el-radio-group vModel={ctx.baseInfo.viewer_type}>
      <el-radio label="ALL">所有人</el-radio>
      <el-radio label="ASSIGN">指定部门/人员</el-radio>
    </el-radio-group>
  )

  if (ctx.baseInfo.viewer_type === 'ASSIGN') {
    res.push(<fc-org-select ref="condition-org" class="org-select-bar" tabList={['dep&user']} vModel={ctx.initiator} />)
  }

  return res
}

function resetPageData() {
  this.baseInfo = JSON.parse(this.baseInfoCopy)
  this.initiator = JSON.parse(this.initiatorCopy)
}

function saveBasicInfo() {
  console.log('this.initiator.dep&user', this.initiator['dep&user'])

  let viewers = this.initiator['dep&user']
  if (this.baseInfo.viewer_type === 'ALL') {
    viewers = []
  } else {
    viewers = viewers.map(item => {
      if (item.userId) {
        return {
          type: 'USER',
          user_id: item.userId
        }
      } else {
        return {
          type: 'DEPARTMENT',
          department_id: item.deptId
        }
      }
    })
  }

  const formData = {
    name: this.baseInfo.name,
    status: this.baseInfo.status,
    viewer_type: this.baseInfo.viewer_type,
    viewers: viewers
  }

  this.pageLoading = true
  saveApprovalBasicDetail(this.type, formData).then(res => {
    if (res.code != 0) throw new Error(res.message)
    this.setDataCopy()
    this.$message({
      message: '保存成功',
      type: 'success'
    });
  }).catch(err => {
    this.$message.error(err.message);
  }).finally(() => {
    this.pageLoading = false
  })
}

function toInitiator(viewers) {
  const depAndUser = []
  viewers.forEach(item => {
    const res = {}
    if (item.type === 'DEPARTMENT') {
      const curItem = DEPARTMENT_MAP[item.department_id]
      res.deptId = curItem.open_department_id
      res.deptName = curItem.name
      res.parentDeptId = curItem.open_department_id
    }
    if (item.type === 'USER') {
      const curItem = USER_MAP[item.user_id]
      console.log('item.userId', item.user_id)
      console.log(curItem)
      res.userId = item.user_id
      res.userName = curItem.name
      res.deptId = curItem.department_ids[0]
    }
    depAndUser.push(res)
  });
  return depAndUser
}

export default {
  name: 'edit-base',
  data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      pageLoading: true,
      initiator: {
        'dep&user': []
      },
      baseInfo: {},
      baseInfoCopy: {},
      initiatorCopy: {}
    }
  },

  methods: {
    initPage() {
      getApprovalBasicDetail(this.type).then(res => {
        if (res.code != 0 || !res.data) return
        this.baseInfo = res.data
        const depAndUser = toInitiator([].concat(this.baseInfo.viewers))
        this.initiator['dep&user'] = depAndUser
        this.setDataCopy()
      }).finally(() => {
        this.pageLoading = false
      })
    },
    setDataCopy() {
      this.initiatorCopy = JSON.stringify(this.initiator)
      this.baseInfoCopy = JSON.stringify(this.baseInfo)
    }
  },
  async created() {
    const depAndUser = await initUserAndDepartments()
    DEPARTMENT_MAP = depAndUser.DEPARTMENT_MAP
    USER_MAP = depAndUser.USER_MAP
    this.initPage();
  },

  render(h) {
    return (
      <div class="edit-approval-base-wrap" vLoading={this.pageLoading}>
        <div class="base-item">
          <em class="label">审批名称：</em>
          <div class="content">{this.baseInfo.name}</div>
        </div>
        <div class="base-item">
          <em class="label">审批类型：</em>
          <div class="content">{APPPROVAL_TYPE_MAP[this.baseInfo.type]}</div>
        </div>
        <div class="base-item">
          <em class="label">审批状态：</em>
          <div class="content" >
            <i class={`info-status ${this.baseInfo.status ? APPROVAL_STATUE_MAP[this.baseInfo.status].class : ''}`}></i>
            {this.baseInfo.status ? APPROVAL_STATUE_MAP[this.baseInfo.status].name : ''}
          </div>
        </div>
        <div class="base-item">
          <em class="label">可发起人：</em>
          <div class="content" style="min-height: 80px;">
            {getViewerDom.call(this, this, h)}
          </div>
        </div>
        <div class="base-btn">
          <el-button type="primary" size="small" onClick={saveBasicInfo.bind(this)}>保存</el-button>
          <el-button size="small" onClick={resetPageData.bind(this)}>重置</el-button>
        </div>
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
@import './editBase.scss';
</style>